import { render, staticRenderFns } from "./AddNotifyMe.vue?vue&type=template&id=7dad2db5"
import script from "./AddNotifyMe.vue?vue&type=script&lang=js"
export * from "./AddNotifyMe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports